import { createPopup } from '@typeform/embed'
import { takeEvery } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import { omit } from 'lodash'

import '@typeform/embed/build/css/popup.css'

import { store } from 'store'
import { showTypeFormPopup } from '../actions'

export function showTypeFormPopupHandler({ payload: { typeFormData, onSubmit } }) {
  const typeForm = createPopup(typeFormData.formId, {
    open: 'load',
    hideHeaders: true,
    hideFooter: true,
    onSubmit: () => {
      typeForm.close()
      if (onSubmit) {
        onSubmit()
      } else {
        store.dispatch(push('/dashboard'))
      }
    },
    ...omit(typeFormData, 'formId'),
  })
}

export default function* showTypFormPopupEvery() {
  yield takeEvery(showTypeFormPopup, showTypeFormPopupHandler)
}
